import VueRouter from 'vue-router'
import global_routes from "@/core/vue-router/global-routes";
import HomeComponent from '../../components/HomeComponent'
import SeoComponent from "@/components/SeoComponent";
import WhyAdvertiseComponent from "@/components/public/WhyAdvertiseComponent";
import {addRegionPathToRoutes, overrideRouterPush} from "@/core/utils/helpers/routesHeper";
import {getCookie} from "@/core/utils/helpers/cookieHelper";
import CookiesEnum from "@/core/constants/cookiesEnum";

const routes = _.concat(global_routes, [
    // Home
    {
        path: '/',
        name: 'home',
        component: HomeComponent,
        meta: {pageCategory: 'homepage'},
    },

    // Why advertise
    {
        path: '/inserieren',
        name: 'why.advertise',
        component: WhyAdvertiseComponent,
    },

    // 404
    {
        path: '/**',
        name: 'seo',
        component: SeoComponent,
        meta: {xpvDontTrack: true},
    },

]);

const router = new VueRouter({
    mode: 'history',

    scrollBehavior(to, from, savedPosition) {
        if (savedPosition && to.name === 'seo') {
            $store.commit('setSearchScrollPosition', savedPosition);
        } else {
            $store.commit('setSearchScrollPosition', null);
            return {x: 0, y: 0};
        }
    },

    routes: addRegionPathToRoutes(routes),
});

router.afterEach((to, from) => {
    if (from.name
        && _.has($store.state.regionData, 'sectionsToHide.storiesWithoutCookie')
        && !$store.state.showStoriesCookieSet
        && getCookie(CookiesEnum.SHOW_STORIES) === 'true'
    ) {
        $store.commit('setShowStoriesCookieSet', true);
    }

    /**
     * The help banner is a static blade element outside the Vue app rendered only
     * on the home route, so it has to be toggled manually when navigating via SPA —
     * otherwise it leaks onto search/profile pages until a hard refresh.
     */
    if (typeof document !== 'undefined') {
        const helpBanner = document.querySelector('.help-top-banner');

        if (helpBanner) {
            if (to.name === 'home') {
                helpBanner.style.display = '';
            } else {
                helpBanner.style.display = 'none';
            }
        }
    }

    /**
     * seoView is only meaningful on the SeoComponent (catch-all) route and drives
     * hiding the top bar on profile views. Leaving that route for home keeps the
     * stale 'profile' value, so the top bar (with the country selector) stays hidden
     * after back-navigation — clear it whenever we land on a non-seo route.
     */
    if (to.name !== 'seo') {
        $store.commit('setSeoView', null);
    }

    utils.updateCanonicalTag(to);

    // the SeoComponent reports different type of pageCategories,
    // so the xpv calls will be made from there
    if (to.meta && to.meta.xpvDontTrack) {
        return;
    }

    if (to.meta
        && to.meta.pageCategory
        && to.meta.pageCategory === 'homepage'
        && typeof homepageResultsId !== 'undefined'
        && typeof xt !== 'undefined') {
        // if it's a first visit (page open)
        // or navigation to the homepage (back button / click on the home link)
        // we want to set the homepage results id which then will get attached
        // to every screen view that navigates away from this page (usually profile views)
        xt.hp = homepageResultsId;
    }

    // XTracking global function
    // track screen views
    if (typeof xpv !== 'undefined') {
        let pageCategory = to.meta && to.meta.pageCategory ? to.meta.pageCategory : null;
        xpv(user, to.fullPath, pageCategory);
    }
});

overrideRouterPush(router);

export default router;
